
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@mui/material';
import { Phone } from '@mui/icons-material';
import getConfig from 'next/config';

import { eventService } from '../../services/homii-services';

const NavbarChatMenu = ({ anchorEl, setAnchorEl }) => {
    const { publicRuntimeConfig } = getConfig();
    const isMenuOpen = Boolean(anchorEl);

    const LiveChatMenuItem = () => {
        if (!publicRuntimeConfig.liveChatEnabled) {
            return null;
        }

        return (
            <MenuItem onClick={handleMenuClose} id="live-menu-item" className='navbar-chat-menu-menu-item'>
                <img src="/assets/images/chat_bubble_icon.png" alt="Chat Bubble" className='navbar-chat-menu-image' />
                Open in LiveChat
            </MenuItem>
        );
    };

    const handleMenuClose = (type) => {
        if (type === 'whatsapp') {
            eventService.logCustomEvent('whatsapp_contact_us', {
                description: 'Clicked on whatsapp from Contact Us page',
            });
        } else if (type === 'phone') {
            eventService.logCustomEvent('click_to_call_contact_us', {
                description: 'Clicked on phone  from Contact Us page',
            });
        }

        setAnchorEl(null);
    };

    return (
        <Menu
            elevation={0}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id="primary-search-account-menu"
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
            slotProps={{
                style: {
                    boxShadow: '0px 13px 52px rgba(0, 0, 0, 0.1)',
                    borderRadius: 5,
                    marginTop: 60,
                },
            }}
        >
            <MenuItem
                className='navbar-chat-menu-menu-item'
                onClick={() => handleMenuClose('whatsapp')}
                id="whatsapp-menu-item"
                component="a"
                href="https://api.whatsapp.com/send?phone=27662818767"
                target="_blank"
                rel="noreferrer"
            >
                <img src="/assets/images/whatsapp_icon.png" alt="WhatsApp" className='navbar-chat-menu-image' />
                Open in WhatsApp
            </MenuItem>
            <MenuItem
                className='navbar-chat-menu-menu-item'
                onClick={() => handleMenuClose('phone')}
                id="office-phone-menu-item"
                component="a"
                href="tel:031 327 6400"
            >
                <Phone fontSize="small" className='navbar-chat-menu-phone' />
                031 327 6400
            </MenuItem>
            <LiveChatMenuItem />
        </Menu>
    );
};

export default NavbarChatMenu;

NavbarChatMenu.propTypes = {
    cities: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    anchorEl: PropTypes.bool,

    setAnchorEl: PropTypes.func,
};

